(ns shared.core.components.menu
  (:require [shared.core.components.interactive :refer [interactive]]
            [shared.core.style :as style]
            [shared.core.components.tooltip :refer [tooltip]]))

(defn menu-item [{:keys [text value first? on-click]}]
  (into [interactive :div {:style {:background-color (style/color :gray :shade-8)
                                   :border-top (if first?
                                                 :none
                                                 (str "1px solid " (style/color :gray :base)))
                                   :color (style/color :white :base)
                                   :font-size 14
                                   :cursor :pointer
                                   :display :flex
                                   :align-items :center
                                   :padding "7px 8px 9px"}
                           :hover-style {:background-color (style/color :gray :base)}
                           :on-click #(on-click value)}]
        [text]))

(defn menu [{:keys [options on-item-click hover?*]}]
  (into [interactive :div {:style {:display :flex
                                   :flex-direction :column}
                           :hover?* hover?*}]
        (->> options
             (filter identity)
             (map-indexed (fn [idx i]
                            [menu-item (assoc i :first? (= idx 0)
                                                :on-click (or (:on-click i) on-item-click))])))))

(defn label-menu [{:keys [label options on-item-click style tooltip-container-style placement show-on-click? arrow?]
                   :or {placement :bottom
                        show-on-click? true
                        arrow? false}}]
  [tooltip
   {:placement placement
    :tooltip-content [menu {:options options
                            :on-item-click on-item-click}]
    :tooltip-container-style (merge {:padding 0}
                                    tooltip-container-style)
    :target-content label
    :show-on-click? show-on-click?
    :interactive? show-on-click?
    :style (merge (when show-on-click? {:cursor :pointer}) style)
    :arrow? arrow?}])
